import { HeaderGroup } from "@tanstack/react-table";
import { TableHeader } from "@/components/atoms/table";
import { cn } from "@/lib/utils";

interface TableHeadProps<TData> {
  headerGroups: HeaderGroup<TData>[];
  /** Keep the header visible while the table scrolls (the table needs a max height) */
  sticky?: boolean;
}

export function TableHead<TData>({ headerGroups, sticky = false }: TableHeadProps<TData>) {
  return (
    <thead className={cn("bg-muted/50", sticky && "sticky top-0 z-20 bg-muted shadow-[0_1px_0_hsl(var(--border))]")}>
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <TableHeader key={header.id} header={header} />
          ))}
        </tr>
      ))}
    </thead>
  );
}
